import * as pdfjsModule from 'pdfjs-dist';
var pdfjs = 'default' in pdfjsModule ? pdfjsModule['default'] : pdfjsModule;
export default pdfjs;